// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { z as zod } from 'zod';

/**
 * Export a module with all its components (tasks and resources)
 * @summary Export Module
 */
export const exportModuleParams = zod
  .object({
    module_id: zod.coerce.string(),
  })
  .strict();

export const exportModuleResponse = zod
  .object({
    data: zod
      .object({
        title: zod.string(),
        description: zod.string().optional(),
        language: zod.string().optional(),
        levels: zod
          .array(
            zod
              .object({
                enumerator: zod.string(),
                title: zod.string(),
                objectives: zod.array(zod.string()).optional(),
              })
              .strict(),
          )
          .optional(),
        workload: zod.number().or(zod.null()).optional(),
        tasks: zod
          .array(
            zod
              .object({
                type: zod.enum(['essay', 'activity', 'event', 'multiple_choice', 'oral_exam']),
                title: zod.string(),
                task_ref: zod.string().or(zod.null()).optional(),
                description: zod.string().or(zod.null()).optional(),
                objectives: zod.record(zod.string(), zod.array(zod.string())).or(zod.null()).optional(),
                level: zod.number().or(zod.null()).optional(),
                sort_index: zod.number().optional(),
                resources: zod
                  .array(
                    zod
                      .object({
                        title: zod.string(),
                        description: zod.string().optional(),
                        citation: zod.string().optional(),
                        media_type: zod.enum(['document', 'video', 'audio', 'jupyter_notebook', 'link', 'archive']),
                        url: zod.string().or(zod.null()).optional(),
                        resource_id: zod.string().or(zod.null()).optional(),
                        resource_ref: zod.string().or(zod.null()).optional(),
                        digest: zod.string().or(zod.null()).optional(),
                        sort_order: zod.number().optional(),
                        oral_exam_relevant: zod.boolean().optional(),
                      })
                      .strict(),
                  )
                  .optional(),
                rubric: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
                evaluation: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
              })
              .strict(),
          )
          .optional(),
        author_id: zod.string(),
        source_module_id: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Import a module from export data
 * @summary Import Module
 */
export const importModuleBody = zod
  .object({
    replaceModuleId: zod.string().or(zod.null()).optional(),
    data: zod
      .object({
        title: zod.string(),
        description: zod.string().optional(),
        language: zod.string().optional(),
        levels: zod
          .array(
            zod
              .object({
                enumerator: zod.string(),
                title: zod.string(),
                objectives: zod.array(zod.string()).optional(),
              })
              .strict(),
          )
          .optional(),
        workload: zod.number().or(zod.null()).optional(),
        tasks: zod
          .array(
            zod
              .object({
                type: zod.enum(['essay', 'activity', 'event', 'multiple_choice', 'oral_exam']),
                title: zod.string(),
                task_ref: zod.string().or(zod.null()).optional(),
                description: zod.string().or(zod.null()).optional(),
                objectives: zod.record(zod.string(), zod.array(zod.string())).or(zod.null()).optional(),
                level: zod.number().or(zod.null()).optional(),
                sort_index: zod.number().optional(),
                resources: zod
                  .array(
                    zod
                      .object({
                        title: zod.string(),
                        description: zod.string().optional(),
                        citation: zod.string().optional(),
                        media_type: zod.enum(['document', 'video', 'audio', 'jupyter_notebook', 'link', 'archive']),
                        url: zod.string().or(zod.null()).optional(),
                        resource_id: zod.string().or(zod.null()).optional(),
                        resource_ref: zod.string().or(zod.null()).optional(),
                        digest: zod.string().or(zod.null()).optional(),
                        sort_order: zod.number().optional(),
                        oral_exam_relevant: zod.boolean().optional(),
                      })
                      .strict(),
                  )
                  .optional(),
                rubric: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
                evaluation: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
              })
              .strict(),
          )
          .optional(),
        author_id: zod.string(),
        source_module_id: zod.string().or(zod.null()).optional(),
      })
      .strict(),
  })
  .strict();

export const importModuleResponse = zod
  .object({
    data: zod.string().or(zod.null()).optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();
